import localforage from 'localforage'
import Api from '../core/Api'
import Offline from './Offline'

// listPhotos est relue puis réécrite en entier : les écritures du modèle passent l'une
// après l'autre, sinon une liste périmée peut écraser un ajout ou un id serveur (MD-688).
let fileEcritures = Promise.resolve();

function exclusif(tache) {
    let resultat = fileEcritures.then(tache, tache);
    fileEcritures = resultat.catch(() => {});
    return resultat;
}

class PhotoFiche {

    static serialize(data){

        let payload = {};

        payload.id = data.id;
        payload.idFibsdd = data.idFi;
        payload.photo64 = data.data64;
        payload.commentaire = data.commentaire || null;

        return payload

    }

    static async addOnline(id) {

        let api = await Api.init();

        let photo = await PhotoFiche.getPhotoFiche(id);
        let payload = PhotoFiche.serialize(photo);
        let idFiche = payload.idFibsdd;

        delete payload.idFibsdd;
        delete payload.id;

        let res = await api.post('/photo/' + idFiche, payload);
        let newId = res.data && res.data.id;

        if (newId) {
            await exclusif(async () => {
                let photos = await PhotoFiche.getList();
                let newList = photos.map(p => {
                    if (p.id === id) {
                        p.id = newId;
                    }
                    return p;
                });

                await localforage.setItem('listPhotos', JSON.stringify(newList));
            });
        }

        await Offline.deleteAction(id, 'PhotoFiche');
        return true;
    }

    static async removeOnline(id) {
        let api = await Api.init();

        try {
            await api.delete('/photo/' + id);
        } catch (err) {
            if (!(err.response && (err.response.status === 403 || err.response.status === 404))) {
                throw err;
            }
        }

        await Offline.deleteAction(id, 'PhotoFiche');

        return true;
    }

    static async addOffline(data) {

        try {

            await exclusif(async () => {
                let photos = await PhotoFiche.getList();
                photos.push(data);
                await localforage.setItem('listPhotos', JSON.stringify(photos));
            });
            await Offline.saveAction({action: 'add', type: 'PhotoFiche', id: data.id});
            return true

        } catch (e) {

            return false

        }

    }

    static async remove(id) {
        try {

            await exclusif(async () => {
                let photos = await PhotoFiche.getList();

                // Prédicat volontairement inversé : _.remove() retire du tableau les
                // éléments qui matchent et RETOURNE ces éléments retirés — ici on
                // persiste donc bien la liste sans l'élément ciblé (double inversion
                // prédicat + valeur persistée). Ne pas "corriger" l'un sans l'autre.
                let newList = _.remove(photos, p => p.id !== id);
                await localforage.setItem('listPhotos', JSON.stringify(newList));
            });

            if(!_.includes(id, 'P-')){

                Offline.saveAction({
                    type: "PhotoFiche",
                    action: "delete",
                    id: id
                })
            } else {
                Offline.deleteAction(id, 'PhotoFiche')
            }

        } catch (err) {
            return false
        }

        return true
    }

    // Pas d'action hors-ligne : seule une photo encore en attente (P-…) est modifiable,
    // et son action « add » transmettra le commentaire à jour (MD-688).
    static async updateCommentaire(id, commentaire) {
        if (!_.includes(String(id), 'P-')) {
            return false;
        }

        return exclusif(async () => {
            let photos = await PhotoFiche.getList();
            let photo = photos.find(p => p.id === id);

            if (!photo) {
                return false;
            }

            photo.commentaire = commentaire;
            await localforage.setItem('listPhotos', JSON.stringify(photos));

            return true;
        });
    }

    static async getListForFiche(idFiche) {

        let photos = await PhotoFiche.getList();
        return photos.filter( p => String(p.idFi) === String(idFiche) )

    }

    static async getPhotoFiche( id ) {

        let list = await PhotoFiche.getList();
        return list.find( p => p.id === id )

    }

    static async getList() {

        return JSON.parse( await localforage.getItem('listPhotos')) || []

    }

}

export default PhotoFiche



// WEBPACK FOOTER //
// ./src/js/models/PhotoFiche.js